// Resolves with the Utah Design System header library once it has loaded.
// The UMD bundle attaches itself to window['@utahdts/utah-design-system-header']
// and emits a `utahHeaderLoaded` document event (repeatedly) until the app calls
// setUtahHeaderSettings(). We resolve on the first event where the library is
// ready.
const GLOBAL_KEY = '@utahdts/utah-design-system-header';

const isReady = (lib) =>
  Boolean(lib && typeof lib.setUtahHeaderSettings === 'function');

export default new Promise((resolve) => {
  if (isReady(window[GLOBAL_KEY])) {
    resolve(window[GLOBAL_KEY]);
    return;
  }
  document.addEventListener('utahHeaderLoaded', () => {
    if (isReady(window[GLOBAL_KEY])) {
      resolve(window[GLOBAL_KEY]);
    }
  });
});
